"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPONENT_NAME = exports.PAGE_NAME = void 0;
// * https://github.com/Wattpad/event-platform/pull/568/files#diff-66b70749365eb097b0efae0202fd5ccce6296501eb7e5528889a520ed1e78cb5
exports.PAGE_NAME = Object.freeze({
    landing: "landing",
    login: "login",
    reading_list: "reading_list",
    reader: "reader",
    search: "search",
    story_details: "story_details",
    browse: "browse",
    browse_landing: "browse_landing",
    profile: "profile",
});
// Event spec: https://docs.google.com/spreadsheets/d/1MultcbAtBPlDICvVbH429U2eMxSVWKsUBRO54hbG56Q/edit?gid=0#gid=0
// protobuf sources:
// * https://github.com/Wattpad/event-platform/pull/568/files#diff-1acec64ff09213155ea4689f9d0914e33e324ab4b1b3d68cc2efe775dddc524c
// * https://github.com/Wattpad/event-platform/pull/568/files#diff-507dc4a5f0ff32a4c493885141f9675376847dae9d3cb92de428f4342ad1cb37
exports.COMPONENT_NAME = Object.freeze({
    above_fold_start_reading: "above_fold_start_reading",
    above_fold_start_writing: "above_fold_start_writing",
    write_drop_down_create_story: "write_drop_down_create_story",
    write_drop_down_my_stories: "write_drop_down_my_stories",
    top_right: "top_right",
    bottom_start_reading: "bottom_start_reading",
    bottom_start_writing: "bottom_start_writing",
    persistent_banner: "persistent_banner",
    left_side_follow: "left_side_follow",
    bottom_add_to_library: "bottom_add_to_library",
    bottom_vote: "bottom_vote",
    bottom_send_comment: "bottom_send_comment",
    bottom_like_comment: "bottom_like_comment",
    right_send_comment: "right_send_comment",
    right_like_comment: "right_like_comment",
    bottom_reply_send_comment: "bottom_reply_send_comment",
    top_right_add: "top_right_add",
    top_right_vote: "top_right_vote",
    fixed_form_left: "fixed_form_left",
    fixed_form_right: "fixed_form_right",
    stories_left: "stories_left",
    profiles_left: "profiles_left",
    timed_popup: "timed_popup",
    fixed_form: "fixed_form",
    signup_to_read_button: "signup_to_read_button",
    table_of_contents: "table_of_contents",
    full_screen: "full_screen",
    right_reply_send_comment: "right_reply_send_comment",
    like: "like", // (readinglist)
});
